// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"5f0b49ce","598":"f724355e","787":"b5629dd8"}[chunkId] + ".chunk.js";
};